/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3MetricsTotalActiveNodesCountRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsTotalActiveNodesCountRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalActiveNodesCountRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/** @internal */
export type GetApiV3MetricsTotalActiveNodesCountRequest$Outbound = {
  end: number | null;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsTotalActiveNodesCountRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalActiveNodesCountRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsTotalActiveNodesCountRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsTotalActiveNodesCountRequest$ {
  /** @deprecated use `GetApiV3MetricsTotalActiveNodesCountRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsTotalActiveNodesCountRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalActiveNodesCountRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsTotalActiveNodesCountRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalActiveNodesCountRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsTotalActiveNodesCountRequest$Outbound;
}

export function getApiV3MetricsTotalActiveNodesCountRequestToJSON(
  getApiV3MetricsTotalActiveNodesCountRequest:
    GetApiV3MetricsTotalActiveNodesCountRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsTotalActiveNodesCountRequest$outboundSchema.parse(
      getApiV3MetricsTotalActiveNodesCountRequest,
    ),
  );
}

export function getApiV3MetricsTotalActiveNodesCountRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsTotalActiveNodesCountRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsTotalActiveNodesCountRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsTotalActiveNodesCountRequest' from JSON`,
  );
}
